import './App.css';
import React from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header.js';
import Footer from './components/Footer.js';
import Home from './pages/Home.js';
import About from './pages/About.js';
import Pricing from './pages/Pricing.js';
import Contact from './pages/Contact.js';
import Classes from './pages/Classes.js';


function App() {
return (
  <>
  <Router>
    <Header />
    <main>
      <Routes>
        <Route exact path='/' element={<Home />} />
        <Route path='/about-us' element={<About />} />
        <Route path='/pricing' element={<Pricing />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/classes' element={<Classes />} />
      </Routes>
    </main>
    <Footer />
  </Router>
  </>
  );
}

export default App;